module.exports = __webpack_public_path__ + "img/bell-2.41541143.svg";